import { PropsWithChildren, ReactNode } from 'react';
import { Box } from '@customink/pigment-react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';

export interface Props {
    children?: ReactNode;
}

const EmptyLayoutBox = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(2),
}));

export function EmptyLayout({ children }: PropsWithChildren<unknown>) {
    return <EmptyLayoutBox>{children}</EmptyLayoutBox>;
}
